import{ GET_VFOVISIT_FORM_LIST,REMOVE_VFOVISIT_DETAIL_LIST } from "../../Types";

const initialState = {
    VFOVisitList: {},
    VFOVisitDetailList:{}
  };

const VFOVisitListReducer = (state = [], action) => {
  switch (action.type) {
    case GET_VFOVISIT_FORM_LIST:
        return { ...state, VFOVisitList: action.payload, };
    case REMOVE_VFOVISIT_DETAIL_LIST:
        return { ...state, VFOVisitDetailList: [], };

    default:
      return state
  }
}
export default VFOVisitListReducer;


